import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CentralEventDetailByIdService } from './central-event-detail-by-id/central-event-detail-by-id.service';

@NgModule({
  imports: [CommonModule],
  providers: [CentralEventDetailByIdService],
})
export class CentralEventsModule {}
